export const defaultFeatureValues = {
  requiredVersion: '0.0.0',
  appleLoginEnabled: false,
  snippetsEnabled: false,
  rsvpEnabled: false,
  copyScheduleEnabled: false,
  quickCreateMaintenanceModeEnabled: false,
  disableAllAiFeatures: false,
  bannerMessage: '',
  bannerLink: '',
  updateScheduleMetadataEnabled: false,
  agendaHeroScheduleAsSource: false,
  magicResultsInPlatformEnabled: false,
  experiencesLayoutTabEnabled: false,
  experiencesCustomColorEnabled: false,
  experiencesColorWheelEnabled: true,
  aiChatEnabled: false,
  chatV2Enabled: false,
  chatModelHandlesFirstMessage: false,
  saveEventEnabled: false,
  singleImageLayoutEnabled: false,
  printEnabled: false,
  condensedListLayoutEnabled: false,
  printLayoutEnabled: false,
  tableLayoutEnabled: false,
  interactionIconEnabled: false,
  gridLayoutEnabled: false,
  freeChatFollowupLimit: 5,
  blockThemesEnabled: false,
  patternThemesEnabled: false,
  sceneThemesEnabled: false,
  showPlaceholderImage: false,
  weekPrintableEnabled: false,
  calendarPrintableEnabled: false,
  multiExportOnPages: false,
  createSchoolExperienceEnabled: false,
  templatesAdminEnabled: false,
  standalonePlannerPrintableEnabled: false,
  eventModalAdvancedOptionsEnabled: false,
  paidPlannerLandingEnabled: false,
  inlineEditingEnabled: false,
  magicUpsellModalEnabled: false,
  plannerAddContentEnabled: false,
  libraryMagicPromptEnabled: false,
  freeTierViewLimit: 2,
  freeTierCollaboratorLimit: 2,
  freeTierExternalSourceLimit: 1,
  outlookIntegrationEnabled: false,
  printableBlockEnabled: false,
  legacyScheduleEnabled: false,
  legacyExperienceEnabled: false,
  createMagicPlannerEnabled: false,
  magicArtifactsEnabled: false,
  magicSchoolsEnabled: false,
  legacyAvailabilityFormEnabled: false,
  legacyConflictFormEnabled: false,
  whatToShowSectionEnabled: false,
  scheduleDatesEnabled: false,
  plannerOnboardingEnabled: false,
  findMySchoolEnabled: false,
  deleteAccountEnabled: false,
  // Defaults ON, unlike the flags above: it gates behavior that already ships to
  // everyone (child views inheriting the planner's interaction apps), so the
  // fallback taken before ConfigCat responds — or if it never does — has to be
  // today's behavior. Flip it off in ConfigCat to migrate.
  interactionInheritEnabled: true,
};

export type FeatureFlag = keyof typeof defaultFeatureValues;
